import { InternalRouteProps } from 'components/App/routes';
import { useEffect, useState } from 'react';
import { AppService } from 'services';

export default function useGetRoutesConfig() {
  const [routes, setRoutes] = useState<string[]>([]);
  const [routesConfig, setRoutesConfig] = useState<InternalRouteProps[]>([])
  useEffect(() => {
    (async () => {
      const config = await AppService.getRouteJsonConfig();
      setRoutes(config?.routes);
      setRoutesConfig(config?.routesConfig)
    })();
  }, []);

  return { routes, routesConfig };
}
